import { Layers } from "appworks/graphics/layers/layers";
import { AutoSpinsCountRadioControl } from "appworks/ui/controls/standard/radio/auto-spins-count-radio-control";
import { AutoRadioControlFactory } from "./auto-radio-control-factory";

export class AutoSpinsCountRadioControlFactory extends AutoRadioControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiButton("autoplay_radio_1") && layer.getFlexiText("autoplay_radio_1_label")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        const data = this.getButtonsAndLabels(layer, "autoplay");

        return [ new AutoSpinsCountRadioControl(data.buttons, data.labels, layer.getFlexiButton("autoplay_radio_left"), layer.getFlexiButton("autoplay_radio_right")) ];
    }
}
